import GridLoader from 'react-spinners/GridLoader';
import { useSelector } from 'react-redux';

const Loader = () => {
  const { loading } = useSelector((state) => state);

  if (loading.pending > 0) {
    return (
      <div className="fixed top-0 h-screen w-screen flex justify-center items-center z-50">
        <div className="bg-black w-screen h-screen absolute opacity-20"></div>
        <GridLoader color="#0b78f5" />
      </div>
    );
  } else {
    return null;
  }
};

export default Loader;
